import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertClientRoutingModule } from './alert-client-routing.module';
import { OtherAlertsComponent } from './components/other-alerts/other-alerts.component';
import { CallOfferAlertsComponent } from './components/call-offer-alerts/call-offer-alerts.component';
import { ListVuesCallOfferComponent } from './components/list-vues-call-offer/list-vues-call-offer.component';


@NgModule({
  declarations: [
    CallOfferAlertsComponent,
    OtherAlertsComponent,
    ListVuesCallOfferComponent,
  ],
  imports: [
    CommonModule,
    AlertClientRoutingModule
  ]
})
export class AlertClientModule { }
